
import axios from 'axios'
import { CategoryRestClient } from 'http/resources'
import { ErrorManager } from 'services'

function getCategories(page, pageCount, criteria) {
    return async dispatch => {
        try {
            dispatch({
                type: 'CATEGORIES_FETCH_CATEGORIES_START',
                payload: {
                    isActiveSearch: typeof criteria !== 'undefined',
                }
            })
            
            const response = await new CategoryRestClient(true).getCategories(page, pageCount, criteria)

            dispatch({
                type: 'CATEGORIES_FETCH_CATEGORIES_SUCCESS',
                payload: {
                    page: page ? page : 0,
                    pageCount: pageCount ? pageCount : 10,
                    categories: response.data.items,
                    totals: response.data.totalItems,
                }
            })
            
        } catch (e) {
            if (e instanceof axios.Cancel) {
                // Nothing to do, just canceled request by next request
            } else {
                dispatch({
                    type: 'CATEGORIES_FETCH_CATEGORIES_FAIL'
                })
    
                dispatch({
                    type: 'ERROR_SET',
                    payload: {
                        title: 'Error en la operación!',
                        description: 'Ha ocurrido un error al intentar obtener las categorías'
                    }
                })
            }
        }   
    }
}

function getCategory(id) {
    return async dispatch => {
        try {
            dispatch({
                type: 'CATEGORIES_FETCH_CATEGORY_START'
            })

            const response = await new CategoryRestClient(true).getCategory(id)

            dispatch({
                type: 'CATEGORIES_FETCH_CATEGORY_SUCCESS',
                payload: {
                    category: response.data
                }
            })
        } catch (e) {
            dispatch({
                type: 'CATEGORIES_FETCH_CATEGORY_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'Error en la operación!',
                    description: 'Ha ocurrido un error al intentar obtener la categoría'
                }
            })
        }
    }
}

function saveCategory(id, data, patch) {
    return async dispatch => {
        try {
            dispatch({
                type: 'CATEGORIES_SAVE_CATEGORY_START',
                payload: {
                    id,
                    patch,
                }
            })

            if (id && !patch) {
                await new CategoryRestClient(true).updateCategory(id, data)
            } else if (id && patch) {
                await new CategoryRestClient(true).patchCategory(id, data)
            } else {
                await new CategoryRestClient(true).createCategory(data)
            }

            dispatch({
                type: 'CATEGORIES_SAVE_CATEGORY_SUCCESS',
                payload: {
                    id,
                    data,
                    patch,
                }
            })

            dispatch({
                type: 'SUCCESS_SET',
                payload: {
                    title: 'Operación Exitosa!',
                    description: id
                        ? 'La categoría se ha actualizado correctamente'
                        : 'La categoría se ha creado correctamente'
                }
            })
        } catch (e) {
            dispatch({
                type: 'CATEGORIES_SAVE_CATEGORY_FAIL'
            })

            dispatch({
                type: 'ERROR_SET',
                payload: {
                    title: 'UPS! Ha ocurrido un error en la operación.',
                    description: ErrorManager.toMessage(e),
                }
            })
        } finally {
            dispatch({
                type: 'CATEGORIES_SAVE_CATEGORY_RESET'
            })
        }
    }
}

function setFormPropertyValue(property, value) {
    return {
        type: 'CATEGORIES_FORM_PROPERTY_VALUE_SET',
        payload: {
            property,
            value
        }
    }
}

function reset(type) {
    return {
        type,
    }
}

export const CategoriesActions = {
    getCategories,
    getCategory,
    saveCategory,
    setFormPropertyValue,
    reset,
}